import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/documents/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/DocumentsLayout'),
    'DocumentsLayout',
  ),
});
